// --------------------------------------------------------------
// Created On: 2021-09-30
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./Warning.module.scss";

// Warning message.
export default function Warning(props: Props): Component {
  return props.message.length > 0 ? (
    <div className={`${styles.body} alert alert-warning`} role="alert">
      {props.message}
    </div>
  ) : null;
}

interface Props {
  message: string;
}
